import React from 'react'
import { useState } from 'react'
import { TextareaDynamicPlaceholder, ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { AccordionItem } from '../../../../components/AccordionItem/AccordionItem'
import { useDebounce } from '../../../../hooks/useDebounce'
import "./Accordion.scss"

const Accordion = (({
    id,
    data,
    changeContent,
    setIsModal,
    ind,
    setCurrentIndex,
    setContentArr,
    readonly = false,
}) => {
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [content, setContent] = useState(data[0]?.properties?.value || [])

    const debounceChange = useDebounce(changeContent, 1000)

    const handleAddPoint = (content) => {
        debounceChange(id,
            [
                {
                    value: '',
                    properties: {
                        value: content
                    }
                }
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        properties: {
                            value: content
                        }
                    }
                } else {
                    return el
                }
            })
        })
    }

    return (
        <div className='accordion-type'
            onContextMenu={(e) => {
                if (!readonly) {
                    e.preventDefault()
                    setCurrentIndex(ind)
                    setIsModal(true)
                }
            }}
        >
            {!readonly &&
                <>
                    {!isEdit ?
                        <ButtonBasic
                            grey
                            text='Добавить новый элемент +'
                            onClick={(e) => {
                                setIsEdit(true)
                            }}
                        />
                        :
                        <div className='accordion-type__fields'>
                            <TextareaDynamicPlaceholder
                                placeholder='Видимый контент'
                                changeValue={title}
                                onChange={e => setTitle(e)}
                                size='s'
                            />

                            <TextareaDynamicPlaceholder
                                placeholder='Скрываемый контент'
                                changeValue={text}
                                onChange={e => setText(e)}
                                size='s'
                            />

                            <ButtonBasic
                                disabled={!title || !text}
                                width='180px'
                                text='Добавить элемент +'
                                onClick={(e) => {
                                    const current_array = [...content, {
                                        title: title,
                                        content: text
                                    }]
                                    setContent(current_array)
                                    setTitle('')
                                    setText('')
                                    handleAddPoint(current_array)
                                }}
                            />

                            <ButtonBasic
                                grey
                                width='auto'
                                text='Закрыть'
                                onClick={(e) => {
                                    setIsEdit(false)
                                }}
                            />
                        </div>}
                </>}

            <div className='accordion-type__list'>
                {content?.map(({ title, content }) => {
                    return <AccordionItem
                        key={title + content}
                        title={title}
                        content={content}
                    />
                })}
            </div>
        </div>
    )
})

export { Accordion }